const FAQ_KEYS = ["cancel", "language", "free", "audio", "certificate", "time", "ai"];

/**
 * `t` is the translate function of the language being shown, and `freeOffer`
 * comes from useFreeCourses — the answer must not claim a number the
 * catalogue does not back. The copy lives under `landing:faq.<key>`.
 */
export function buildFaq(t, freeOffer) {
	return FAQ_KEYS.map((key) => ({
		q: t(`landing:faq.${key}.q`),
		a: t(`landing:faq.${key}.a`, { offer: freeOffer }),
	}));
}
